// Estados del CRM de órdenes. Tiene que coincidir con
// monitoreo-api/components/indication-crm/statuses.js.
//
// Los "anteriores" son los de la primera versión del CRM: los casos viejos los
// conservan, pero ya no se pueden asignar. "Turno asignado" es el que antes se
// llamaba "Turno tomado" (misma clave).
export const STATUS_META = {
  new: { label: "Nueva", cls: "is-new", active: true },
  callback: {
    label: "Rellamar",
    cls: "is-callback",
    active: true,
    assignable: true,
  },
  "pending-documentation": {
    label: "Pendiente de documentación",
    cls: "is-pending",
    active: true,
    assignable: true,
  },
  "appointment-taken": {
    label: "Turno asignado",
    cls: "is-taken",
    assignable: true,
    button: "button-green-new",
  },
  "previously-assigned": {
    label: "Previamente asignado",
    cls: "is-previous",
    assignable: true,
  },
  desisted: {
    label: "Desiste",
    cls: "is-desisted",
    assignable: true,
    button: "button-red-new",
  },
  "no-answer": {
    label: "No responde",
    cls: "is-no-answer",
    assignable: true,
    button: "button-red-new",
  },
  contacted: {
    label: "Contactado (anterior)",
    cls: "is-legacy",
    active: true,
    legacy: true,
  },
  "appointment-proposed": {
    label: "Turno propuesto (anterior)",
    cls: "is-legacy",
    active: true,
    legacy: true,
  },
  closed: { label: "Cerrado (anterior)", cls: "is-legacy", legacy: true },
};

const keys = (predicate) =>
  Object.keys(STATUS_META).filter((key) => predicate(STATUS_META[key]));

export const ALL_STATUSES = Object.keys(STATUS_META);
export const ACTIVE_STATUSES = keys((status) => status.active);
export const CURRENT_STATUSES = keys((status) => !status.legacy);
export const LEGACY_STATUSES = keys((status) => status.legacy);
export const ASSIGNABLE_STATUSES = keys((status) => status.assignable);
export const TERMINAL_STATUSES = keys((status) => !status.active);

export const statusLabel = (status) =>
  STATUS_META[status]?.label || status || "Nueva";
